import api from '@utils/api';
import einsteinutils from '@utils/einsteinutils';
import axios from 'axios';
import React, { useEffect, useRef, useState } from 'react';
import SwiperCore, { Keyboard, Navigation } from 'swiper';
import { Swiper, SwiperSlide } from 'swiper/react';
import useBreakpoint from '@utils/useBreakpoint';
import '@moncler/scss/components/products-carousel-simplified/products-carousel-simplified.scss';
import ProductTile from '@moncler/components/listing/ProductTile';
import { useTranslation } from 'react-i18next';
import analytics from '@utils/analytics';
SwiperCore.use([Keyboard, Navigation]);
const ProductCarousel = (props) => {
    const { t } = useTranslation();
    const [products, setProducts] = useState([]);
    const [loading, setLoading] = useState(true);
    const swiperRef = useRef();
    const prevRef = useRef(null);
    const nextRef = useRef(null);
    const currentBreakpoint = useBreakpoint();
    const isMobile = currentBreakpoint < window.mqObj.md;
    // products fetch effect
    // priority rule
    // listIds -> categoryId -> recommenderId
    useEffect(() => {
        const cancelTokenSource = axios.CancelToken.source();
        if (props.listIds) {
            api.getProductTiles(props.listIds.split(',')).then((data) => {
                setProducts(data);
                setLoading(false);
            });
        }
        else if (props.categoryId) {
            api.searchProducts({ id: props.categoryId }).then((data) => {
                setProducts(data.products);
                setLoading(false);
                if (props.pageType == 'search') {
                    analytics.productImpressionsRecommended(data.products, 'recommended-search_no_results');
                }
            });
        }
        else if (props.recommenderId) {
            einsteinutils.productRecommendations(props.recommenderId, (rec) => {
                setProducts(rec.products);
                setLoading(false);
            }, cancelTokenSource, null, null, null, (errorData) => {
                console.log(errorData);
                setLoading(false);
            });
        }
        else {
            // no products will be fetched
            setLoading(false);
        }
        return () => cancelTokenSource.cancel();
    }, [props.listIds, props.categoryId, props.recommenderId]);
    useEffect(() => {
        if (!loading) {
            props.onResults(products.length > 0);
        }
    }, [loading]);
    const renderArrows = () => (React.createElement("div", { className: "products-carousel__arrows" },
        React.createElement("button", { type: "button", ref: prevRef, className: "swiper-button-prev", "aria-label": t('carousel.prevslidemessage') },
            React.createElement("i", { className: "icon--chevron-left-big", "aria-hidden": true })),
        React.createElement("button", { type: "button", ref: nextRef, className: "swiper-button-next", "aria-label": t('carousel.nextslidemessage') },
            React.createElement("i", { className: "icon--chevron-right-big", "aria-hidden": true }))));
    return (React.createElement("div", { className: "container" }, products.length === 0 ? (loading ? (React.createElement("div", { className: "swiper-container skeleton-carousel" },
        React.createElement("ul", { className: "swiper-wrapper" },
            React.createElement("li", { className: "swiper-slide" },
                React.createElement("div", { className: "product-tile single-slide__img product-tile--carousel" },
                    React.createElement("div", { className: "product-tile__card" },
                        React.createElement("div", { className: "product-tile__link" },
                            React.createElement("div", { className: "product-tile__image-wrapper" },
                                React.createElement("div", { className: "product-image" })))),
                    !props.hidelabels && (React.createElement("div", { className: "product-tile__info single-slide__labels" },
                        React.createElement("p", { className: "product-tile__name" }, "loading"),
                        !props.hideprice && React.createElement("span", { className: "product-tile__price" }, "loading")))))))) : ('no products fetched')) : (React.createElement(React.Fragment, null,
        !isMobile && renderArrows(),
        React.createElement(Swiper, { onSwiper: (swiper) => (swiperRef.current = swiper), keyboard: true, navigation: {
                prevEl: prevRef.current,
                nextEl: nextRef.current,
            }, className: "no-overflow-container", slidesPerView: "auto", spaceBetween: 16, threshold: 10, watchSlidesProgress: true, breakpoints: {
                600: {
                    slidesPerView: 3,
                },
                1024: {
                    slidesPerView: 4,
                },
            } }, products.map((product, i) => (React.createElement(SwiperSlide, { key: i },
            React.createElement(ProductTile, { type: "RECS", hidelabels: props.hidelabels, hideprice: props.hideprice, pageType: props.pageType, hoverDifferent: props.hoverDifferent, recommender: props === null || props === void 0 ? void 0 : props.recommenderId, product: product, isSimplified: true, noSwatch: true, index: i }))))),
        isMobile && renderArrows()))));
};
export default ProductCarousel;
